<template>
    <rkm-row>
        <rkm-col cols="12">
            <rkm-area
                class="mb-2"
                type="fieldset"
                title="ATRIBUIR PARA AS JORNADAS SELECIONADAS"
            >
                <rkm-form ref="RkmForm">
                    <rkm-row>

                        <rkm-col cols="3">
                            <rkm-form-time-picker
                                label="Horário Inicial"
                                v-model="jornada.horaInicial"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-form-time-picker
                                label="Horário Final"
                                v-model="jornada.horaFim"
                            />
                        </rkm-col>

                        <rkm-col cols="auto">

                            <rkm-button
                                :label="false"
                                @click.stop="atribuir()"
                                color="primary"
                                :disabled="handleAtribuir()"
                            >
                                Atribuir
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                @click.stop="resetForm"
                                color="secondary"
                                :disabled="!jornada.horaInicial && !jornada.horaFim"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-area>
        </rkm-col>
    </rkm-row>
</template>

<script>

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    data:() => ({
        jornada: {
            data: null,
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            diasSemana:null,
            semanaId: null,
            unidadeId: null,
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
        },
        disabled: false,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        atribuir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                        let msg = ''

                        this.model.jornadasNotSave.map((item, index) => {

                            if(item.selecionado){

                                const existeJornada = this.handleJornada(item, index)

                                if(existeJornada){

                                    const dataInicial = moment(item.dataInicial).format('DD/MM/YYYY HH:mm')
                                    const dataFinal = moment(item.dataFinal).format('DD/MM/YYYY HH:mm')

                                    msg = msg.concat('<br/>', item.geralDiaSemanaDescricao, ' - ', dataInicial, ' - ', dataFinal, ' - Conflito de horário.')
                                }

                                if(!existeJornada){

                                    const dataInicial = moment(item.dataInicial, 'YYYY-MM-DD').format('YYYY-MM-DD')
                                    const dataFinal = moment(item.dataFinal, 'YYYY-MM-DD').format('YYYY-MM-DD')

                                    const horaInicial = moment(dataInicial.concat(' ', this.jornada.horaInicial), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                                    const horaFinal = moment(dataFinal.concat(' ', this.jornada.horaFim), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')

                                    if(this.jornada.horaInicial){

                                        item.dataInicial = horaInicial
                                    }

                                    if(this.jornada.horaFim) {

                                        item.dataFinal = horaFinal
                                    }

                                    this.jornadaAlterada = true
                                }
                            }
                        })

                        this.mensagemConflito(msg)
                        this.resetForm()
                        this.$emit('getCalendar')
                })
        },
        handleJornada(item, index) {

            return this.model.jornadasNotSave.find((j, i) => {

                const dataInicial = moment(item.dataInicial, 'YYYY-MM-DD').format('YYYY-MM-DD')
                const dataFinal = moment(item.dataFinal, 'YYYY-MM-DD').format('YYYY-MM-DD')

                const horaInicial = moment(dataInicial.concat(' ', this.jornada.horaInicial), 'YYYY-MM-DD HH:mm:ss')
                const horaFinal = moment(dataFinal.concat(' ', this.jornada.horaFim), 'YYYY-MM-DD HH:mm:ss')

                return index !== i && moment(horaInicial).isBetween(
                    moment(j.dataInicial, 'YYYY-MM-DD HH:mm'),
                    moment(j.dataFinal, 'YYYY-MM-DD HH:mm')
                )
                || index !== i && moment(horaFinal).isBetween(
                        moment(j.dataInicial, 'YYYY-MM-DD HH:mm'),
                        moment(j.dataFinal, 'YYYY-MM-DD HH:mm')
                    )
                || index !== i && moment(horaInicial).isSame(
                        moment(j.dataInicial, 'YYYY-MM-DD HH:mm:ss')
                    )
                || index !== i && moment(horaFinal).isSame(
                        moment(j.dataFinal, 'YYYY-MM-DD HH:mm:ss')
                    )
                || index !== i && moment(
                        this.getFormatedDate(horaInicial, 'YYYY-MM-DD HH:mm')
                    )
                    .isBefore(
                        j.dataInicial,
                    )
                && moment(this.getFormatedDate(horaFinal, 'YYYY-MM-DD HH:mm'))
                    .isAfter(
                        j.dataFinal,
                    )
            })
        },
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.jornada.infraestruturaId = localAtendimento.id
            } else {

                this.jornada.infraestruturaId = null
            }
        },
        mensagemConflito(msg){

            if(msg){

                this.showAlert('Não foi possível atribuir a jornada nas seguintes datas: '  + msg)
            }
        },
        resetForm() {

            this.jornada.vagas = ''
            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
        },
        handleAtribuir() {

            if (this.jornada.horaInicial || this.jornada.horaFim) {

                if (this.selecionados) {
                    return false
                }
            }

            return true
        }
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        selecionados: { type: Boolean, required: true },
        id: { type: Number }
    },
}
</script>